const LoadingScreen = () => {
  return (
    <div className="loading-container">
        <img src="/classement/default_lp_loader.gif" alt=""/>
    </div>
  )
}
export default LoadingScreen